// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Actions_wrapper__nlB9K","paper":"Actions_paper__3U0a3","list":"Actions_list__3UKtH","item":"Actions_item__1zvVr","button":"Actions_button__3gHZR"};